import { cilReload } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { CButton, CFormInput, CImage } from "@coreui/react-pro";
import { FC } from "react";
// import defaultInsignia from "../../../../../assets/images/avatars/default-avatar.png";
import { DefaultAvatar } from "../../../../../assets/images";

interface InsigniaUploaderProps {
  label?: string;
  helperText?: string;
  readOnly?: boolean;
  state: {
    preview?: string;
    invalid: boolean;
    valid: boolean;
    feedbackInvalid?: string;
    feedbackValid?: string;
    height?: number;
    width?: number;
  };
  controller: {
    resetImage?: (id?: string) => void;
    setImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus: () => void;
  };
}

const InsigniaImage: FC<InsigniaUploaderProps> = ({
  label,
  helperText,
  readOnly,
  state,
  controller,
}) => {
  return (
    <>
      <div className="text-center mb-2 h-200px">
        <CImage
          rounded
          thumbnail
          src={state.preview ?? DefaultAvatar}
          width={state.width ?? "200px"}
          height={state.height ?? "200px"}
        />
      </div>
      {!readOnly && (
        <CFormInput
          className="has-validation"
          id="image"
          type="file"
          label={
            <div className="d-flex clearfix justify-content-center align-items-center">
              <div className="float-start text-secondary">
                {label ?? "Company Logo"}
              </div>
              <div className="ms-2 float-end">
                <CButton
                  size="sm"
                  variant="outline"
                  color="primary"
                  onClick={() => {
                    if (controller.resetImage) controller.resetImage("image");
                  }}
                >
                  <CIcon icon={cilReload} size="sm" />
                </CButton>
              </div>
            </div>
          }
          text={
            <div className="text-secondary clearfix d-flex col align-items-center">
              <div className="float-start">
                {helperText ?? "MIME Type: image/*"}
              </div>
            </div>
          }
          invalid={state.invalid}
          valid={state.valid}
          feedbackInvalid={state.feedbackInvalid}
          feedbackValid={state.feedbackValid}
          size="sm"
          onChange={controller.setImage}
          onFocus={() => controller.onFocus()}
        />
      )}
    </>
  );
};

export default InsigniaImage;
